var _path, _circle, _path2, _circle2, _path3, _circle3, _mask, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHappyCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 70,
    viewBox: "0 0 68 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.625 64.5315V59.0626C64.4375 54.6877 60.0625 52.5002 53.5 52.5002C49.9393 52.5002 47.0227 53.1442 44.75 54.4321",
    stroke: "#1B1E59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 42.6159,
    r: 5.56251,
    stroke: "#1B1E59",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 64.5314V59.0625C3.1875 54.6877 7.56251 52.5002 14.125 52.5002C17.6857 52.5002 20.6023 53.1441 22.875 54.432",
    stroke: "#1B1E59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.125,
    cy: 42.6158,
    r: 5.56251,
    stroke: "#1B1E59",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9375 70.0001V63.4376C44.75 59.0627 40.375 56.8752 33.8125 56.8752C27.25 56.8752 22.875 59.0627 20.6875 63.4376V70.0001",
    stroke: "#1B1E59",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.8125,
    cy: 47.0315,
    r: 5.56251,
    fill: "#05F29B",
    stroke: "#1B1E59",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_2001_10596",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 4.37501C1 1.95876 2.95876 0 5.37501 0H62.2501C64.6664 0 66.6251 1.95876 66.6251 4.37501V17.5C66.6251 19.9163 64.6664 21.875 62.2501 21.875H53.5001V28.4375L44.7501 21.875H38.1876L33.8126 28.4375L29.4375 21.875H22.875L14.125 28.4375V21.875H5.37501C2.95876 21.875 1 19.9163 1 17.5V4.37501Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.37501C1 1.95876 2.95876 0 5.37501 0H62.2501C64.6664 0 66.6251 1.95876 66.6251 4.37501V17.5C66.6251 19.9163 64.6664 21.875 62.2501 21.875H53.5001V28.4375L44.7501 21.875H38.1876L33.8126 28.4375L29.4375 21.875H22.875L14.125 28.4375V21.875H5.37501C2.95876 21.875 1 19.9163 1 17.5V4.37501Z",
    fill: "white",
    stroke: "#1B1E59",
    strokeWidth: 4,
    mask: "url(#path-7-inside-1_2001_10596)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 3.80554L15.614 8.38812L15.7262 8.73361H16.0895H20.9079L17.0098 11.5658L16.7159 11.7793L16.8281 12.1248L18.3171 16.7074L14.4189 13.8752L14.125 13.6617L13.8311 13.8752L9.93294 16.7074L11.4219 12.1248L11.5342 11.7793L11.2403 11.5658L7.3421 8.73361H12.1605H12.5238L12.636 8.38812L14.125 3.80554Z",
    fill: "#05F29B",
    stroke: "#1B1E59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8125 3.80554L35.3015 8.38812L35.4137 8.73361H35.777H40.5954L36.6973 11.5658L36.4034 11.7793L36.5156 12.1248L38.0046 16.7074L34.1064 13.8752L33.8125 13.6617L33.5186 13.8752L29.6204 16.7074L31.1094 12.1248L31.2217 11.7793L30.9278 11.5658L27.0296 8.73361H31.848H32.2113L32.3235 8.38812L33.8125 3.80554Z",
    fill: "#05F29B",
    stroke: "#1B1E59"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 3.80554L54.989 8.38812L55.1012 8.73361H55.4645H60.2829L56.3848 11.5658L56.0909 11.7793L56.2031 12.1248L57.6921 16.7074L53.7939 13.8752L53.5 13.6617L53.2061 13.8752L49.3079 16.7074L50.7969 12.1248L50.9092 11.7793L50.6153 11.5658L46.7171 8.73361H51.5355H51.8988L52.011 8.38812L53.5 3.80554Z",
    fill: "#05F29B",
    stroke: "#1B1E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHappyCustomer);
export default __webpack_public_path__ + "static/media/Icon_HappyCustomer.d213a4dcf4775f5521532b4f3d913614.svg";
export { ForwardRef as ReactComponent };